module.exports = __webpack_public_path__ + "img/alice.1f74fffc.jpg";